import React, { useState } from "react";
import styles from "./Candidate.module.css"
import illustration from "../../Images/CanididateOutreachimg.jpeg";
import illustration1 from "../../Images/candidateoutreactimage2.png";
import illustration2 from "../../Images/candidateoutreactimage3.jpg";


const CandidateOutreach = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "Can AI send personalized messages?",
      answer:
        "Yes, every message is automatically personalized based on candidate data and job role.",
    },
    {
      question: "How does AI personalize candidate messages?",
      answer:
        "AI analyzes candidate data (skills, seniority, industry, and past engagement) to create hyper-personalized messages that sound human and context-aware.",
    },
    {
      question: "How do follow-ups work?",
      answer:
        "AI schedules automated reminders for non-responders and keeps engagement high without manual effort.",
    },
    {
      question: "Does it integrate with ATS and LinkedIn?",
      answer:
        "Absolutely. ToxBox AI integrates with all major ATS platforms and LinkedIn.",
    },
    {
      question: "Is candidate data secure?",
      answer:
        "Industry-standard encryption, GDPR, and privacy compliance ensure full security.",
    },
    {
      question: "Can I track campaign performance?",
      answer:
        "Yes, real-time analytics help optimize outreach strategy for maximum engagement."
    }
  ];

  const benefits = [
    {
      id: 1,
      title: "Hyper-Personalized AI Messages",
    },
    {
      id: 2,
      title: "Bulk Outreach with Precision",
    },
    {
      id: 3,
      title: "Multi-Channel Engagement",
    },
    {
      id: 4,
      title: "Automated Follow-Ups",
    },
    {
      id: 5,
      title: "Seamless ATS Integration",
    },
    {
      id: 6,
      title: "Analytics & Reporting",
    },
  ];

  const sixthItem = [
    "Time-Saving Benefits – Automate repetitive outreach and follow-ups",
    "Improved Candidate Experience – AI personalization ensures each candidate feels valued",
    "Data-Driven Insights – Analytics show which campaigns and messages work best",
    "Faster Hiring Process – Reduced time-to-hire with automated engagement",
    "Cost Efficiency – Lower overheads and reduce reliance on staffing agencies",
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      {/* Hero section */}
      <section className={styles.hero}>
        <div className={styles.imageWrapper}>
          <img
            src={illustration}
            alt="Candidate Outreach"
            className={styles.image}
          />
          <div className={styles.textOverlay}>
            <h1 className={styles.headline}>
              AI Recruiter – Candidate Outreach
            </h1>
            <p className={styles.subheadline}>
              Engage top candidates instantly with <span>ToxBox AI</span>.
              Automate outreach campaigns, send hyper-personalized messages,
              track engagement, and hire smarter.
            </p>
          </div>
        </div>
      </section>

      {/* Second Section */}
      <section className={styles.secondSection}>
        <div className={styles.secondContent}>
          <h2 className={styles.secondHeadline}>
            AI Recruiter – Supercharge Candidate Outreach with ToxBox AI
          </h2>
          <p className={styles.secondSubheadline}>
            Automate personalized outreach, engage top talent faster, and close
            hires efficiently with AI-driven recruitment campaigns.
          </p>
          <button className={styles.cta}>
            Start Smart Candidate Outreach Today
          </button>
        </div>
      </section>

      {/* Third Section */}
      <section className={styles.thirdSection}>
        <div className={styles.thirdContent}>
          <h2 className={styles.thirdHeadline}>
            Struggling to Engage Top Candidates? Let AI Do the Heavy Lifting.
          </h2>
          <p className={styles.thirdParagraph}>
            Recruiters often spend <strong>50–70% of their time</strong> on
            repetitive outreach. <span>ToxBox AI</span> automates these tasks
            while keeping communication personal, timely, and engaging.
          </p>
        </div>

        {/* Cards */}
        <div className={styles.cards1}>
          <div className={styles.card1}>
            <p>
              70% of recruiters say outreach is their most time-consuming task.
            </p>
          </div>

          <div className={styles.card1}>
            <p>Personalized AI messaging boosts response rates 3–5x.</p>
          </div>

          <div className={styles.card1}>
            <p>
              Automated follow-ups increase candidate engagement by up to 80%
            </p>
          </div>
        </div>
      </section>

      {/* Fourth Section */}
      <section className={styles.fourthSection}>
        <div className={styles.fourthContent}>
          <h2 className={styles.fourthHeadline}>
            How ToxBox AI Engages Candidates – Step by Step
          </h2>

          <div className={styles.cards2}>
            <div className={styles.card2}>
              <p>
                Import Candidate Data – Upload from LinkedIn, ATS, or CSV. Smart
                segmentation by skills, experience, location, and engagement
                history.
              </p>
            </div>

            <div className={styles.card2}>
              <p>
                AI-Powered Personalization – AI crafts hyper-personalized
                messages and adjusts tone for seniority, role type, or industry.
              </p>
            </div>

            <div className={styles.card2}>
              <p>
                Automated Campaign Scheduling – Send messages at optimal times
                via Email, LinkedIn, SMS, WhatsApp.
              </p>
            </div>

            <div className={styles.card2}>
              <p>
                Real-Time Engagement Tracking – Analytics for opens, clicks,
                replies, and response time. Dashboard highlights candidates
                needing follow-ups.
              </p>
            </div>

            <div className={styles.card2}>
              <p>
                Automated Follow-Ups – AI sends reminders to non-responders and
                customizes frequency, message type, and tone.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Fifth Section */}
      <section className={styles.fifthSection}>
        {/* Headline at top */}
        <h2 className={styles.fifthHeadline}>
          Powerful Features to Maximize Candidate Engagement
        </h2>

        {/* Split layout */}
        <div className={styles.fifthWrapper}>
          {/* Left side with GIF background */}
          <div className={styles.fifthLeft} />

          {/* Right side with benefits */}
          <div className={styles.fifthRight}>
            <div className={styles.fifthNumberBg}></div>
            <ul className={styles.fifthBenefitList}>
              {benefits.map((item) => (
                <li key={item.id} className={styles.fifthBenefitItem}>
                  <span className={styles.fifthNumber}>{item.id}</span>
                  <div>
                    <h4>{item.title}</h4>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Sixth Section */}

      <section className={styles.sixthSection}>
        {/* Headline */}
        <h2 className={styles.sixthHeadline}>
          Transform Your Recruitment Process with AI
        </h2>

        {/* Cards wrapper */}
        <div className={styles.cardsWrapper}>
          {sixthItem.map((text, index) => (
            <div key={index} className={styles.cardItem}>
              {text}
            </div>
          ))}
        </div>
      </section>


      {/* Seventh Section */}
      <section className={styles.seventhSection}>
        <div className={styles.seventhContent}>
          <h2>Seamless Integration with Your ATS & Platforms</h2>
        </div>

        {/* Feature Cards Wrapper */}
        <div className={styles.cards7Wrapper}>
          <div className={styles.cards7}>
            <p>Auto-sync candidate lists</p>
          </div>
          <div className={styles.cards7}>
            <p>Real-time updates for response tracking</p>
          </div>
          <div className={styles.cards7}>
            <p>Multi-channel outreach automation</p>
          </div>
        </div>

        {/* Testimonial */}
        <div className={styles.seventhtestimonial}>
          <div className={styles.leftSectionimg}>
            <img src={illustration2} alt="Integration illustration" />
          </div>
          <div className={styles.rightSectioncontent}>
            <p>
              Company Y integrated ToxBox AI with Greenhouse and automated outreach to 1,000+ candidates weekly,
              increasing hiring efficiency by 40%.
            </p>
            <button className={styles.seventhcta}>
              Integrate with Your ATS Now
            </button>
          </div>
        </div>
      </section>





      {/* Section eigth */}
      <section className={styles.eightSection}>
        <h1 className={styles.eightHeadline}>
          Trusted by Recruitment Teams Globally
        </h1>

        <div className={styles.testimonialWrapper}>
          {/* Testimonial 1 */}
          <div className={styles.testimonialCard}>
            <div className={styles.personImageWrapper}>
              <img
                src={illustration1}
                alt="HR Lead, TechCorp"
                className={styles.personImage}
              />
            </div>
            <div className={styles.testimonialContent}>
              <p className={styles.testimonialText}>
                “ToxBox AI helped us engage candidates faster and more
                effectively than ever before.”
              </p>
              <p className={styles.personRole}>– HR Lead, TechCorp</p>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className={styles.testimonialCard}>
            <div className={styles.personImageWrapper}>
              <img
                src={illustration2}
                alt="Talent Acquisition Manager, FinServe"
                className={styles.personImage}
              />
            </div>
            <div className={styles.testimonialContent}>
              <p className={styles.testimonialText}>
                “Our response rate jumped from 15% to 52% in the first month.”
              </p>
              <p className={styles.personRole}>
                – Talent Acquisition Manager, FinServe
              </p>
            </div>
          </div>
        </div>
      </section>





      {/* FAQ Section */}
      <section className={styles.faqSection} id="faq">
        <h2 className={styles.faqHeadline}>Frequently Asked Questions</h2>
        <div className={styles.faqList}>
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`${styles.faqItem} ${activeIndex === index ? styles.active : ""
                }`}
            >
              <button
                className={styles.faqQuestion}
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                <span>{activeIndex === index ? "−" : "+"}</span>
              </button>
              {activeIndex === index && (
                <div className={styles.faqAnswer}>{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default CandidateOutreach;




